import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { TradeStatus } from '../HeroCardsReturnUser/Cards/TradeCard/constants';

// TODO REO-2947 add logic in here for expiresSoon status once STC has it added
export default function useGetTradeInStatus() {
  const { statusAgnosticTrade } = useContext(TradeContext);
  const { status, vehicleValue } = statusAgnosticTrade ?? {};

  switch (status) {
    case 'Active':
      return TradeStatus.Active;
    case 'Expired':
      return TradeStatus.Expired;
    default:
      return vehicleValue === 0 ? TradeStatus.Pending : TradeStatus.None;
  }
}
